import {
  SupportTicketFilterNames,
  supportTicketFilterData,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import { DateFilterOperator } from "@redotech/redo-model/views/advanced-filters/date-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { DateTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const LastCustomerMessageAtAdvancedFilter: DateTableFilter = {
  type: AdvancedFilterType.DATE,
  Icon: CalendarIcon,
  operators: [
    DateFilterOperator.WITHIN,
    DateFilterOperator.BEFORE,
    DateFilterOperator.AFTER,
  ],
  data: supportTicketFilterData[
    SupportTicketFilterNames.LAST_CUSTOMER_MESSAGE_AT
  ],
  displayName: "Last customer message",
};
